export const collaboratorStatus = ['actif', 'inactif'] as const
export type CollaboratorStatus = (typeof collaboratorStatus)[number]

export const collaboratorStatusLabel: Record<CollaboratorStatus, string> = {
  actif: 'Actif',
  inactif: 'Inactif',
}
